export default __webpack_public_path__ + "static/media/xplosion.6ca21466.svg";